// ---------------------------------------------------------------------------
// PWA Caisse Tablette — Simple table grid (fallback when no floor plans)
// ---------------------------------------------------------------------------

import type { Table } from '@/lib/types';
import TableButton from '@/components/TableButton';

interface TableGridProps {
  tables: Table[];
  onTableClick: (id: string) => void;
  selectedId?: string | null;
}

export default function TableGrid({ tables, onTableClick, selectedId }: TableGridProps) {
  if (tables.length === 0) {
    return (
      <div className="flex items-center justify-center py-12 text-gray-400 text-sm">
        Aucune table configuree
      </div>
    );
  }

  return (
    <div className="grid grid-cols-3 sm:grid-cols-4 gap-3 p-4">
      {tables.map((table) => (
        <TableButton
          key={table.id}
          table={table}
          isSelected={selectedId === table.id}
          onClick={() => onTableClick(table.id)}
        />
      ))}
    </div>
  );
}
